import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { X, CircleNotch, DownloadSimple } from "@phosphor-icons/react";
import { toast } from "sonner";
import { useLang } from "../context/LangContext";
import api from "../lib/api";

export const previewableExt = (name) => {
  const ext = name.includes(".") ? name.split(".").pop().toLowerCase() : "";
  if (ext === "pdf") return "pdf";
  if (["png", "jpg", "jpeg"].includes(ext)) return "image";
  return null;
};

export const FilePreview = ({ file, machineId, onClose }) => {
  const { t } = useLang();
  const d = t.dossier;
  const [url, setUrl] = useState(null);
  const kind = previewableExt(file.file_name);

  useEffect(() => {
    let objUrl;
    api.get(`/machines/${machineId}/dossier/${file.id}/download`, { responseType: "blob" })
      .then((res) => {
        objUrl = URL.createObjectURL(res.data);
        setUrl(objUrl);
      })
      .catch(() => { toast.error(d.downloadError); onClose(); });
    return () => objUrl && URL.revokeObjectURL(objUrl);
  }, [file.id]);

  const download = () => {
    if (!url) return;
    const a = document.createElement("a");
    a.href = url; a.download = file.file_name; a.click();
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
      className="fixed inset-0 z-[70] flex items-center justify-center p-4 bg-[#0A0F1A]/70 backdrop-blur-sm" onClick={onClose}>
      <motion.div initial={{ opacity: 0, y: 20, scale: 0.98 }} animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ ease: [0.16, 1, 0.3, 1] }} onClick={(e) => e.stopPropagation()}
        className="w-full max-w-4xl bg-white rounded-md border border-slate-200 h-[86vh] flex flex-col" data-testid="file-preview-modal">
        <div className="flex items-center gap-3 px-5 py-3 border-b border-slate-200">
          <p className="flex-1 min-w-0 truncate text-sm font-semibold text-[#0F172A]">{file.file_name}</p>
          <button onClick={download} className="text-slate-400 hover:text-emerald-600 transition-colors p-1.5" title={d.download} data-testid="file-preview-download"><DownloadSimple size={18} /></button>
          <button onClick={onClose} className="text-slate-400 hover:text-[#0F172A] p-1.5" data-testid="file-preview-close"><X size={18} /></button>
        </div>
        <div className="flex-1 min-h-0 bg-slate-100 flex items-center justify-center overflow-auto rounded-b-md">
          {!url ? (
            <CircleNotch size={28} className="text-emerald-500 animate-spin" />
          ) : kind === "pdf" ? (
            <iframe title={file.file_name} src={url} className="w-full h-full border-0" data-testid="file-preview-pdf" />
          ) : (
            <img src={url} alt={file.file_name} className="max-w-full max-h-full object-contain" data-testid="file-preview-image" />
          )}
        </div>
      </motion.div>
    </motion.div>
  );
};
